<style scoped>
.main-container {
  padding: 100px 10px;
  max-width: 1200px;
  margin: 0 auto;
}
.mapConten{
  max-width: 800px;
  text-align: right;
}
</style>

<template>
  <div>
    <div class="main-container">
      <Row :gutter="60" class="p-b-20">
          <i-col span="16">
            <bmap :center-point="defaultCenterPoint"></bmap>
          </i-col>
          <i-col span="8">
              <aside>
                <Row class="p-b-20">
                  <i-col span="24">
                    <p class="p-b-5"><a @click="changeMap('成都')" class=" text-16" :class="(defaultCity === '成都')? 'active':''">成都公司</a></p>
                    <ul class="text-black-8f">
                        <li>地址 成都市高新区天府软件园B3栋</li>
                        <li>电话 +028 85939933</li>
                        <li>邮箱 mkt@oohforce.com</li>
                    </ul>
                  </i-col>
                </Row>

                <Row class="p-b-20 p-t-5">
                  <i-col span="24">
                    <p class="p-b-5"><a @click="changeMap('上海')" class=" text-16" :class="(defaultCity === '上海')? 'active':''">上海办事处</a></p>
                    <ul class="text-black-8f">
                        <li>地址 上海市浦东新区丁香路1089号中邦风雅颂</li>
                        <li>电话 +86 18602108803</li>
                        <li>邮箱 zhaoyan@oohforce.com</li>
                    </ul>
                  </i-col>
                </Row>

                <Row class="p-b-20 p-t-10">
                  <i-col span="24">
                    <p class="p-b-5"><a @click="changeMap('青岛')" class=" text-16" :class="(defaultCity === '青岛')? 'active':''">青岛公司</a></p>
                    <ul class="text-black-8f">
                        <li>地址 青岛市市北区黑龙江中路450号地铁大厦A座712室</li>
                        <li>电话 +86 13853176770</li>
                        <li>邮箱 taoshuai@oohforce.com</li>
                    </ul>
                  </i-col>
                </Row>

                <Row class=" p-t-10">
                  <i-col span="24">
                    <p class="p-b-5"><a @click="changeMap('厦门')" class=" text-16" :class="(defaultCity === '厦门')? 'active':''">厦门办事处</a></p>
                    <ul class="text-black-8f">
                        <li>地址 厦门市思明区前埔工业园61号万物社C302至C307</li>
                        <li>电话 +86 13328320519</li>
                        <li>邮箱 mkt@oohforce.com</li>
                    </ul>
                  </i-col>
                </Row>

              </aside>
          </i-col>
      </Row>

      <Row :gutter="60" class="p-t-50">
        <i-col span="16">
          <p class="p-t-20 text-16 text-black-8f" style="text-indent:2em;">成都欧孚士文化传媒有限公司，利用移动互联网、大数据、人工智能等先进技术；建立“资源标准化、交易程序化、管理痕迹化、运营市场化”的资源交易模式；通过SaaS平台，实现了“公开、公平、公正”的运营理念和“效率、信用、满意度”的服务宗旨。公司为租赁型资产运营中各环节的用户提供高效、安全、透明的运营、咨询、交易等全方位的服务。</p>
        </i-col>
        <i-col span="8">
          <aside>
          <img style="width: 200px;" src="../../assets/imgs/code.jpg"/>
          </aside>
        </i-col>
      </Row>
    </div>

    <div class="search-footer">
      Copyright © 2017~2021 成都欧孚士文化传媒有限公司. All Rights Reserved <a
        class="footer-href"
        href="https://beian.miit.gov.cn/"
        target="_Blank"
      > 蜀ICP备17004980号-1</a>
    </div>
  </div>
</template>

<script>
import bmap from '@/components/bmap.vue'

export default {
  name: 'contact',
  components: {
    bmap
  },
  data () {
    return {
      defaultCenterPoint: {},
      defaultCity: '成都',
      address: [
        { code: '成都', center: { lng: 104.076673, lat: 30.550755 } },
        { code: '上海', center: { lng: 121.56175, lat: 31.23443 } },
        { code: '青岛', center: { lng: 120.388306, lat: 36.070431 } },
        { code: '厦门', center: { lng: 118.182506, lat: 24.488134 } }
      ]
    }
  },
  created () {
    this.defaultCenterPoint = this.address[0].center
  },
  methods: {
    changeMap (citycode) {
      this.address.forEach(item => {
        if (item.code === citycode) {
          this.defaultCenterPoint = item.center
          this.defaultCity = item.code
        }
      })
    }
  }
}
</script>
